import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak
} from 'keycloak-angular';
import { environment } from '@Env';

const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /^(?!.*\/assets).*$/i
});

// const wsCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
//   urlPattern: new RegExp(`^${environment.wsUrl}(/.*)?$`, 'i')
// });
// const catalogCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
//   urlPattern: new RegExp(`^${environment.catalogUrl}(/.*)?$`, 'i')
// });
// const authCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
//   urlPattern: new RegExp(`^${environment.authUrl}(/.*)?$`, 'i')
// });

export const provideKeycloakAngular = () => provideKeycloak({
    config: {
      url: environment.authUrl,
      realm: environment.authRealm,
      clientId: environment.authClientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
      checkLoginIframe: false
    },
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [
          apiCondition
        ]
      }
    ]
  });
